/**
 * @generated SignedSource<<71cb6cef428aefb24c86351be9dbc00f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackagesListEmptyState_customer$data = {
  readonly club: {
    readonly " $fragmentSpreads": FragmentRefs<"useClubIsSellingPackages_club">;
  };
  readonly " $fragmentType": "PackagesListEmptyState_customer";
};
export type PackagesListEmptyState_customer$key = {
  readonly " $data"?: PackagesListEmptyState_customer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackagesListEmptyState_customer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackagesListEmptyState_customer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useClubIsSellingPackages_club"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Customer",
  "abstractKey": null
};

(node as any).hash = "4d44d9f80f5ab5398860630434534b7f";

export default node;
